import { ICustomLookupColumn, ICustomLookupOptions, ICustomSearchScreenDialogStyle } from '../constants';

const LOOKUP_COLUMNS: ICustomLookupColumn[] = [
    {
        dataField: 'LotSerial',
        caption: 'Lot',
        allowResizing: true,
        minWidth: 150,
        width: 150,
        fixed: true,
    },
    {
        dataField: 'EnteredDate',
        caption: 'Entered',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: true,
    },
    {
        dataField: 'ExpiryDate',
        caption: 'Expiry',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: false
    },
    {
        dataField: 'AvailableQuantity',
        caption: 'Available',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: false
    },
    {
        dataField: 'Description',
        caption: 'Description',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: false
    },
];

export const SEARCH_SCREEN_DIALOG_STYLE: ICustomSearchScreenDialogStyle = {
    width: 592,
    maxWidth: 892,
    height: 495,
    maxHeight: 495
};

export const warehouseProductBinLotLookupConstants: ICustomLookupOptions = {
    columns: LOOKUP_COLUMNS,
    dialogStyle: SEARCH_SCREEN_DIALOG_STYLE,
    hideColumnHeaders: false,
    disableGridColumnLines: false,
    dataPrefix: 'Details'
};
